import { SERVER_URI, TEST_URI, SERVER_URI1 } from '../Constants/server'
import { apiGet, apiPost, apiPut } from '../Utils/axios';


const GET_PRODUCT_TYPE = SERVER_URI + '/customer_pos/getProductType';
const GET_CARD_SWIPE = SERVER_URI + '/dashboard/getCustomerPlayPoint/';

const GET_COMBO_PRODUCT = SERVER_URI + '/customer_pos/getComboProduct';
const GET_PRODUCT = SERVER_URI + '/customer_pos/getProduct/';
const REDEEM_ORDER = SERVER_URI + '/customer_pos/redeemOrder/';
const UPDATE_STOCK = SERVER_URI + '/dashboard/updatestock'

const SEND_WAIVER_OTP = SERVER_URI + '/waiver/sendOtp/';
const VERIFY_WAIVER_OTP = SERVER_URI + '/waiver/verifyOtp';
const ADD_WAIVER = SERVER_URI + '/waiver/addNewWaiver';
const GET_WAIVER = SERVER_URI + '/Waiver/get-waiver';

export default {
  getProductType: async function () {
    return apiGet(GET_PRODUCT_TYPE);
  },
  getCardSwipe: async function (id) {
    return apiGet(GET_CARD_SWIPE + id);
  },
  getComboProduct: async function (payload) {
    return apiPost(GET_COMBO_PRODUCT, payload);
  },
  getProduct: async function (product_type_id) {
    return apiGet(GET_PRODUCT + product_type_id);
  },
  redeemOrder: async function (card_no, payload) {
    return apiPost(REDEEM_ORDER + card_no, payload);
  },
  update_stock: async function (payload) {
    return apiPost(UPDATE_STOCK, payload);
  },
  AddWaiver: async function (payload) {
    return apiPost(ADD_WAIVER, payload);
  },
  SendOtp: async function (mobile) {
    return apiGet(SEND_WAIVER_OTP + mobile);
  },
  VerifyOtp: async function (payload) {
    return apiPost(VERIFY_WAIVER_OTP, payload);
  },
  AddWaiver: async function (payload) {
    return apiPost(ADD_WAIVER, payload);
  },
 getWaiver: async function (mobile) {
    return apiGet(`${GET_WAIVER}?mobile=${mobile}`);
  },
};